import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAvatarPharmacistFilledreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/avatar-pharmacist-filled",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M9.86328 19.7266C4.44336 19.7266 0 15.2832 0 9.86328C0 4.44336 4.44336 0 9.86328 0C15.2832 0 19.7266 4.44336 19.7266 9.86328C19.7266 15.2832 15.2832 19.7266 9.86328 19.7266ZM4.58008 10.5566C4.58008 11.3477 5.11719 11.875 5.89844 11.875H7.83203V13.8086C7.83203 14.6094 8.35938 15.127 9.15039 15.127H10.5664C11.3574 15.127 11.8848 14.6094 11.8848 13.8086V11.875H13.8281C14.6094 11.875 15.1367 11.3477 15.1367 10.5566V9.13086C15.1367 8.35938 14.6094 7.82227 13.8281 7.82227H11.8848V5.88867C11.8848 5.09766 11.3574 4.58008 10.5664 4.58008H9.15039C8.35938 4.58008 7.83203 5.09766 7.83203 5.88867V7.82227H5.88867C5.10742 7.82227 4.58008 8.35938 4.58008 9.13086V10.5566Z",
			fill: "#363F89"
		})
	})
});
export default SvgAvatarPharmacistFilledreact;
